/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen., Ryan Duffy & Warren Dowey
 */

export class ProjectUsersModel {
  private _projectId?: string;
  private _userId?: string;
  private _roleId?: string;
  private _favourite?: boolean;
  private _lastVisited?: Date;
  private _oldRoleId?: string;

  constructor(projectId?: string, userId?: string, roleId?: string, favourite?: boolean, lastVisited?: Date, oldRoleId?: string) {
    this._projectId = projectId;
    this._userId = userId;
    this._roleId = roleId;
    this._favourite = favourite;
    this._lastVisited = lastVisited;
    this._oldRoleId = oldRoleId;
  }

  get projectId(): string {
    return this._projectId;
  }

  set projectId(value: string) {
    this._projectId = value;
  }

  get userId(): string {
    return this._userId;
  }

  set userId(value: string) {
    this._userId = value;
  }

  get roleId(): string {
    return this._roleId;
  }

  set roleId(value: string) {
    this._roleId = value;
  }

  get favourite(): boolean {
    return this._favourite;
  }

  set favourite(value: boolean) {
    this._favourite = value;
  }

  get lastVisited(): Date {
    return this._lastVisited;
  }

  set lastVisited(value: Date) {
    this._lastVisited = value;
  }

  get oldRoleId(): string {
    return this._oldRoleId;
  }

  set oldRoleId(value: string) {
    this._oldRoleId = value;
  }

  toJson(): Object {
    const object = {
      project_id: this.projectId,
      user_id: this.userId,
      role_id: this.roleId,
      favourite: this.favourite,
      old_role_id: this.oldRoleId,
    };
    Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): ProjectUsersModel {
    return new ProjectUsersModel(
      input['project_id'],
      input['user_id'],
      input['role_id'],
      input['favourite'],
      input['old_role_id']
    );
  }
}
